import { selectOption } from './selectOption';
import { getSubTable } from './getSubTable';

export const submitDeleteEntry = (phpPath, deleteData, option, phpSubComponent) => {

    return function (dispatch) {

        if (window.confirm("Confirmi stergerea acestui element?")){
            fetch(phpPath, {
                method: "POST",
                body: deleteData
            })
                .then(response => response.json())
                .then(data => {
                    dispatch({
                        type: "DELETE_SUBMITTED"
                    });
                    if (phpSubComponent) {
                        dispatch(
                            getSubTable(phpSubComponent)
                        )
                    } else {
                        dispatch(
                            selectOption(option)
                        )
                    }
                })
                .catch((error) => {
                    dispatch({
                        type: "DELETE_SUBMITTED",
                        payload: error
                    })
                })
        }
    }
};


// WEBPACK FOOTER //
// ./src/actionCreators/submitDeleteEntry.js